import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@shared/ui/tooltip"

interface CustomTooltipProps {
  message: string;
  iconSize?: number;
  className?: string;
  side?: "top" | "bottom" | "left" | "right";
}

export function CustomTooltip({ message, iconSize = 16, className, side = "top",  }: CustomTooltipProps) {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild className="mb-1">
          <Info
            size={iconSize}
            className={`text-gray-500 cursor-pointer ${className || ""}`}
          />
        </TooltipTrigger>
        <TooltipContent side={side} className="max-w-sm">
          <p>{message}</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
